var _style, _text, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCormorantgaramond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "240 50 320 95",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    text {\n      font-family: 'Cormorant Garamond', serif;\n      font-weight: 400;\n      font-size: 72px;\n      fill: #6f6f6f;\n    }\n    line {\n      stroke: #9a9a9a;\n      stroke-width: 1;\n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    y: 110,
    x: 400
  }, "ephemera")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y2: 130,
    x2: 550,
    y1: 130,
    x1: 250
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCormorantgaramond);
export default __webpack_public_path__ + "static/media/logo-cormorantgaramond.b8291a3f17fea7aa79ed076cc93261ae.svg";
export { ForwardRef as ReactComponent };